// extracted by mini-css-extract-plugin
module.exports = {"voiceConfigPage":"VoiceConfigPage_voiceConfigPage__3oyEY","voiceConfigMenu":"VoiceConfigPage_voiceConfigMenu__v_XqQ","voiceConfigPanel":"VoiceConfigPage_voiceConfigPanel__3jHd3"};